import { create } from "zustand";
import { persist } from "zustand/middleware";

const currentDate = new Date().toISOString().split("T")[0];

const useFilterStore = create(
  persist(
    (set) => ({
      zoneWiseFilters: {
        date: `${currentDate}`,
        VehicleTypeId: "",
        ownerTypeId: "",
        vehicleNumber: "",
        transferStationId: "",
        corporationIds: [],
      },


      circleWiseFilters: {
        date: `${currentDate}`,
        VehicleTypeId: "",
        ownerTypeId: "",
        vehicleNumber: "",
        transferStationId: "",
        corporationIds: [],
      },

      tab: null,

      // Action to update Zone Wise Filters
      setZoneWiseFilter: (filterKey, value) =>
        set((state) => ({
          zoneWiseFilters: {
            ...state.zoneWiseFilters,
            [filterKey]: value,
          },
        })),

      // Action to update Circle Wise Filters
      setCircleWiseFilter: (filterKey, value) =>
        set((state) => ({
          circleWiseFilters: {
            ...state.circleWiseFilters,
            [filterKey]: value,
          },
        })),

      // Reset Zone Wise Filters
      resetZoneWiseFilters: () =>
        set({
          zoneWiseFilters: {
            date: "",
            VehicleTypeId: "",
            ownerTypeId: "",
            vehicleNumber: "",
            transferStationId: "",
            corporationIds: [],
          },
        }),

      // Reset Circle Wise Filters
      resetCircleWiseFilters: () =>
        set({
          circleWiseFilters: {
            date: "",
            VehicleTypeId: "",
            ownerTypeId: "",
            vehicleNumber: "",
            transferStationId: "",
            corporationIds: [],
          },
        }),

      setTab: (newTab) =>
        set({
          tab: newTab, // Set tab to a new value
        }),

      // Search action can trigger any logic you want (e.g., API call)
      searchZoneWise: () => {
        // Your search logic for zone-wise filters
      },

      searchCircleWise: () => {
        // Your search logic for circle-wise filters
      },
    }),
    {
      name: "sat-filters-storage", // name for the storage (localStorage key)
    }
  )
);

export default useFilterStore;
